import { Component, inject, PLATFORM_ID } from '@angular/core';
import { BaseComponent } from '../../shared/base/base.component';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-home',
  standalone: false,

  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})

export class HomeComponent extends BaseComponent {
  private platformId = inject(PLATFORM_ID);

  private _questionStart = false;

  get questionStart(): boolean {
    return this._questionStart;
  }

  set questionStart(value: boolean) {
    if (this._questionStart !== value) {
      this._questionStart = value;      
    }
  }

  getScreenWidth(): number {
    if (isPlatformBrowser(this.platformId)) {
      return window.innerWidth;
    }
    return 0;
  }
}
